import { useDispatch, useSelector } from 'react-redux'
import SelectBox from 'components/form/SelectBox'
import {
  clearSelectedCampaign,
  fetchCampaigns,
  fetchChannels,
  selectChannel,
} from 'features/editlog/editlogSlice'

const ChannelFilter = () => {
  const dispatch = useDispatch()
  const { channels, selectedChannel, selectedCampaign, isLoading } =
    useSelector(state => state.editlog)

  const onClickFetchChannels = async () => {
    if (!channels.length) await dispatch(fetchChannels())
  }

  return (
    <SelectBox
      placeholder="비즈채널 선택"
      value={selectedChannel}
      onValueChange={v => {
        dispatch(selectChannel(v))
        if (selectedCampaign && selectedCampaign.bizChannelId !== v.id) {
          dispatch(clearSelectedCampaign())
          dispatch(fetchCampaigns(v))
        }
      }}
      onClick={onClickFetchChannels}
      disabled={isLoading || channels.length === 0}>
      {channels.map(channel => (
        <SelectBox.Item key={channel.id} value={channel}>
          <span className="limit_line">{channel.name}</span>
          <span className="txt_addr">{channel.pcUrl}</span>
          <span className="txt_addr">{channel.mobileUrl}</span>
        </SelectBox.Item>
      ))}
    </SelectBox>
  )
}

export default ChannelFilter

ChannelFilter.propTypes = {}
